import styles from "../../assets/css/remittance.new-rate-compare.module.scss";
import AboungLogo from "./AboungLogo";
// import ImageComponent from "./ImageComponent";

import Vector from "./Vector";

const RateCard = ({
  isAbound = false,
  providerName = "",
  exchangeRate = "",
  transferFee = "",
  recipientGets = "",
  isPositive = true,
  diff = "",
  partnerLogo = "",
  isDark = true,
}) => {
  return (
    <div className={styles.fxCard}>
      <div className={styles.logoContainer}>
        <div>
          <img
            className={styles.providerIcon}
            alt="logo" //src={Abound}
            src={partnerLogo}
          />
        </div>
        <div className={styles.providerInfo}>
          {isAbound ? (
            <div>
              <div>
                <AboungLogo fill={isDark ? "#FFF" : "#1A1A1A"} />
                {/* <ImageComponent
                  src="https://timesclub-static.s3.us-east-2.amazonaws.com/Website+images/fx-rate-compare/instarem.png"
                  cls={styles.xeLogo}
                /> */}
              </div>
              <div className={styles.aboundText}>Standard</div>
            </div>
          ) : (
            <div className={styles.otherProviderName}>{providerName}</div>
          )}
        </div>
      </div>
      <div className={styles.fxRateContainer}>
        <div className={styles.exchangeRate}>
          <div className={styles.key}>Exchange rate</div>
          <div className={styles.exchangeRateValueContainer}>
            <div
              className={
                isPositive
                  ? styles.exchangeRateDotGreen
                  : `${styles.exchangeRateDotGreen} ${styles.exchangeRateDotYellow}`
              }
            />
            <div className={`${styles.value} ${styles.exchangeRateValue}`}>
              {exchangeRate}
            </div>
          </div>
        </div>
        <div className={styles.transferTextContainer}>
          <div className={styles.key}>Transfer fee</div>
          <div className={styles.value}>{transferFee}</div>
        </div>
        <div className={styles.recipientContainer}>
          <div className={styles.key}>Recipient gets</div>
          <div className={styles.value}>
            <div className={styles.valueBold}>{recipientGets}</div>
            {!isAbound && (
              <div className={styles.gainLoss}>
                <div className={styles.gainLossIcon}>
                  <Vector
                    cls={isPositive ? "" : styles.rotate}
                    fill={isPositive ? "#19B03A" : "#FF6E64"}
                  />
                </div>
                <div
                  className={
                    isPositive
                      ? styles.gainLossValue
                      : `${styles.gainLossValue} ${styles.lossValue}`
                  }
                >
                  {diff}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
export default RateCard;
